export const environment = {
  production: false,
  client_id: 'polar-client',
  client_secret: 'polar-secret',
  autoMl:"",
  skipOauth:false,
  enableUserLog: true,
  devicePulse: false,
  host: 'https://device.polar.senzmate.com/service',
  azureAd: {
    clientId: "",
    tenantId: "common"
  },
  azurePackageUpgradeLink: "",
  azurepageLink: "https://portal.azure.com/#home",
  contactUsLink: "https://www.senzmate.com/company/contact/",
  azurepackageFreeId: "",
  azurepackageBasicId: "",
  azurepackagePremiumId: "",
  chatbotHost:"",
  rootCauseHost:"",
  firebase: {
    apiKey: 'AIzaSyA9uKFEIqgW63abTdvYTqb3gS6r-60FRpI',
    authDomain: 'poalkre-c3d33.firebaseapp.com',
    databaseURL: 'https://senzagro-c3d33.firebaseio.com',
    projectId: 'senzagro-c3d33',
    storageBucket: 'senzagro-c3d33.appspot.com',
    messagingSenderId: '283658892245',
    appId: '1:283658892245:web:e206dc51d4a2719e75c35c',
    measurementId: 'G-E5NKHDMS7N'
  },
   useFirebase:false,
};
